/**
 * React owns only the sticky step header cell.
 * Track heads are painted imperatively by PaintController (column virtualization)
 * so horizontal scroll does not re-render React and wipe the body pool.
 */
import { MAX_INSTRUMENT_SLOT_COUNT } from "../../../../src/lib/audio";
import { useStoreSelector } from "../../../../src/lib/store";
import { getLabActions } from "../labActions";
import { projectStore } from "../store/projectStore";

export function TrackerHeader() {
  const trackCount = useStoreSelector(projectStore, s => s.instruments.length);
  const atMax = trackCount >= MAX_INSTRUMENT_SLOT_COUNT;

  return (
    <tr data-tracker-header="1">
      <th className="step-head">
        <button
          type="button"
          className="tracker-add-track"
          title={
            atMax
              ? `Maximum ${MAX_INSTRUMENT_SLOT_COUNT} tracks`
              : `Add instrument track (${trackCount} → ${trackCount + 1})`
          }
          aria-label="Add instrument track"
          disabled={atMax}
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();
            getLabActions()?.addTrack();
          }}
        >
          +
        </button>
      </th>
    </tr>
  );
}
